module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2c"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("CHAPTER 2")])])]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('h2', {
    staticClass: "h2c1"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Expedition Planning")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "stickup"
  }, [_vm._v("W")]), _vm._v("hen the directors of the NOLS Patagonia branch plan a seventy-day semester, their decisions involve kayaks, horses, planes, boats, trucks, thousands of pounds of food, high expectations, unknown terrain, glaciers, devilish Patagonia weather, and even a tactfully written letter to the Chilean navy. The logistics for these trips are formidable, but the principles for planning them are the same principles you or I can use to plan a three-day trip to the Smoky Mountains.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The celebrated adventurer Bill Tilman once said, “Any worthwhile expedition can be planned on the back of an envelope.” Expedition planning needn’t be overly complex or metaphysical. Part of the fun of the outdoors comes in spontaneous trips when you call a few friends, throw some things in a pack, and head for the hills. But paradoxically, the people most successful at “spontaneous” trips are those with the practical experience to bring the right gear, some maps, and enough fuel, and the leadership experience to choose the right people for the venture—even if they leave for the wilds on the spur of the moment.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("In the summer of 1998, Neal Beidleman, a guide credited with saving many lives on the ill-fated 1996 Mount Everest expedition, gave a lecture at the International Design Conference in Aspen, Colorado, about “designing” an expedition. The gist of Beidleman’s lecture was that any design—whether for a ")]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("product, a building, or an expedition—depends on leadership, common group objectives, good equipment, teamwork, and a balance between the flexibility to improvise and a rigid plan to fall back on in the event of a crisis. Beidleman went on to say that the weaknesses in the design of the Everest expedition were exposed by the harsh conditions. What struck me most about Beidleman’s lecture was his portrayal of an expedition as a living, breathing entity wherein every part of the design—the equipment, the people, the leadership, and the objectives—all act on each other to form either a successful trip or a failed trip.")])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Some people seem to have a knack for planning good expeditions. Every year, fellow NOLS instructor and friend Dave Glenn organizes an odd assortment of rednecks, government land managers, and green tree huggers, throws them all together on three or four rubber rafts, floats them through a rough river, and has them finish the adventure making deep political concessions to each other just from the joy of completing a well-designed trip. Dave succeeds at making these impossibly unlikely combinations of people work partly from having a knack with people but also from years of experience, mastery of the planning fundamentals, and surely the experiential benefit of some failures.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("In this chapter you will learn a simple outline of variables to consider in designing your own trip. Every trip in the outback involves five main elements: team and leadership; expedition goals; route planning; contingency plans; and ration planning. All these elements, while considered separately for the sake of this chapter, are interconnected and interdependent. The people you bring on your trip will determine the expedition goals; good rations will help keep your group healthy enough to achieve its goals; a well-planned route will help morale. The relationships between these five elements of your plan are endless but the point here is simple: The well-designed trip comes of good planning. Every trip is different, but this outline will help you plan every time.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Team and leadership")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Expedition goals")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Route planning")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Contingency plans")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Ration planning")])]), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _c('a', {
    attrs: {
      "id": "ch02lev1sec1"
    }
  }), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("Team and Leadership")])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('h4', {
    staticClass: "h4a"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('a', {
    attrs: {
      "id": "ch02lev2sec1"
    }
  }, [_vm._v("IT ALL BEGINS WITH YOU")])]), _c('a', {
    attrs: {
      "id": "ch02lev2sec1"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Before you go, make an honest appraisal of your abilities and experience. This is not the time to pad your résumé, but a time to evaluate your skills, physical condition, and background with some modesty so you will not choose a trip beyond your competence.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Perhaps you are a raw beginner with little or no outdoor experience but a strong athlete and tough as leather. Maybe you have Woody Allen’s physique and his affinity for the outdoors as well. Perhaps you have camped a dozen times in the last two years but always with an organized program. Maybe you have a technical background in rock climbing but have never traveled in the Arizona desert, where you are planning to go for your next adventure.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("Everyone has certain strengths, be they athletic abilities, mental resilience, or extraordinary patience; and everyone has certain liabilities—fear of heights or poor orientation, for instance. Every year, inexperienced hikers get injured or lost or killed because they attempt trips beyond their abilities. This is not meant to scare you but to raise your awareness. When planning your trip ask yourself these questions:")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• What is the sum total and nature of my outdoor experience?")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Would I be able to handle an emergency such as a seriously injured or lost party member, or a situation in which I myself was injured?")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Do I have the physical conditioning and psychological mindset to complete this trip?")])]), _c('h4', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "ch02lev2sec1"
    }
  }), _c('a', {
    attrs: {
      "id": "ch02lev2sec2"
    }
  }, [_vm._v("CHOOSING YOUR TEAMMATES")])]), _c('a', {
    attrs: {
      "id": "ch02lev2sec2"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The most important decision you make in planning your trip is who gets to go with you. Your teammates are your best resource in the day-to-day routine and in an emergency. Having good people along—people you enjoy and trust—is the foundation of a good expedition.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ch02lev2sec2"
    }
  }, [_vm._v("After taking stock of your own abilities, consider the abilities and personalities of your teammates. You want a group with matching abilities, compatible personalities, and good judgment. It’s certainly fine to bring people of varying skills, but those going should know in advance and agree to be flexible enough to accommodate weaker or less experienced teammates or, when traveling with those who have superior skills, be in a learning role. If you invite a friend with a penchant for long grueling days on the trail, along with a ")]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("friend who fancies lazy reverie under a banyan tree, you may be asking for a quarrel. Invite a couple intent on consummating their nuptials at every spare moment, and you’ll chafe the lone ascetic in the group. Members invited on your trip should know what the pace and style of the trip will be. Perhaps you want to complete a challenging route and do dozens of peak ascents. Perhaps you all just want to get out, relax, fish, and cook lots of good meals. The important thing is that everyone in the group knows what to expect.")])]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('p', {
    staticClass: "indentb"
  }, [_vm._v("If possible, sample your friends on a day hike before you invite them to join you on a long expedition. Even a day of hiking together will give you some idea of their fitness, their attitudes, their moods, and their quirks.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Here are some questions to ask yourself when choosing your teammates:")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Do they have common sense and good judgment? Would you trust the prospective teammate to get you out of the backcountry if you became incapacitated?")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Are they of your ability? Will you be comfortable traveling with someone who is much more conservative in judgment than you are, or, conversely, with someone who is much more aggressive?")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Will you enjoy each other’s company?")])]), _c('h4', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _c('a', {
    attrs: {
      "id": "ch02lev2sec3"
    }
  }, [_vm._v("GROUP SIZE")])]), _c('a', {
    attrs: {
      "id": "ch02lev2sec3"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Small groups are mobile and involve simple logistics. With a small group you don’t have to convene an assembly for every decision about where to hike or what meals to bring. When I go on trips where I want to cover a lot of terrain or climb peaks, I much prefer to travel with a small team. There is less to go wrong and fewer opinions to sway.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Four is often cited at NOLS as a minimum number of people for an expedition. In the event of an injury, one person can stay with the injured party while two people go for help. While traveling in a group of four may be safer than, say, traveling with just one buddy, you should not always feel obligated to travel with three other people. However, you must consider that a smaller group’s advantages mean diminished resources (people) in the event of an emergency.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Large groups are raucous good fun but require more formal organization, logistics, and leadership. I love to go on a river trip with four boats and 20 people given one condition: Someone else organizes everything. If the small group can float like a butterfly and sting like a bee, the large group moves like a well-meaning jellyfish.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ch02lev2sec3"
    }
  }), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("In a large group you have more personalities, which adds to the fun, but can also slow down the whole decision-making process. Ever try to pick a restaurant with 15 relatives hovering about? With a large group, you have more chances of someone getting injured, simply because of the statistics, but also more resources and options available.")])]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Large groups obviously require more room to camp, and can have a tougher impact on the environment just by sheer volume. If you travel in a large group, you have to work harder to minimize your impact on the environment.")])]), _c('h4', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _c('a', {
    attrs: {
      "id": "ch02lev2sec4"
    }
  }, [_vm._v("TRAVELING SOLO")])]), _c('a', {
    attrs: {
      "id": "ch02lev2sec4"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Traveling solo in the backcountry is at once liberating, free, and lonely. The solitude may be just what your soul needs. Alone you will likely see more wildlife, have more flexibility in everything from choosing a campsite to cooking a meal, and perhaps find focus and clarity. But those new to solo travel need to be prepared for the sense of isolation in a vast space. If you travel alone you are in a sense climbing without a rope, and as such, you have less room for error. When traveling solo, you need to be more conservative in nearly everything you do. The river you might cross with a group of friends on hand may be too risky as a lone traveler. An off-trail shortcut you’d take with even one more person might not be wise when alone.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("If you do decide to travel solo, learn the art in increments. Start with a single night or two and work your way up to traversing the Pacific Crest Trail. Since you will have no one in the immediate area to watch over you unless there are nearby travelers, you should leave an itinerary with a trusted friend or relative. The itinerary should include the following:")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• A detailed route plan.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Where your car will be parked if you drive to the roadhead. Usually the first thing a search and rescue team will check is whether your car is still parked at the roadhead.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• A generous but well-defined overdue date. If you plan to go for three days, you might tell your contact person you plan to be back on day three but not to send the cavalry until day four or five. The “freak time” should be clearly defined so there is no ambiguity and your friend doesn’t call for help either too early or too late.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Specific medical problems you have (e.g., diabetes, heart problems, epilepsy, etc.).")])]), _c('div', {
    staticClass: "inline_group"
  }, [_c('a', {
    attrs: {
      "id": "ch02lev2sec4"
    }
  }, [_c('img', {
    staticClass: "landscape_60",
    attrs: {
      "alt": "image",
      "src": "images/f0037-01.jpg"
    }
  })]), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "ch02lev2sec4"
    }
  }), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("Choosing compatible teammates is one of the important decisions in expedition planning. A NOLS course in the northern Talkeetna Mountains of Alaska. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Fredrik Norrsell")])])]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('p', {
    staticClass: "bull"
  }, [_vm._v("• A list of the gear, food, and fuel you are carrying. It is useful for rescue teams to know whether you have a light summer sleeping bag or a heavy bag, a high-quality tent or a sheet of plastic, and food enough for two days or four.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Whom to call if you do not arrive on time. Typically this would be the local sheriff or search and rescue team.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• A description of what you plan to do in an emergency situation (e.g., use a cell phone, a radio, a signal mirror, or a signal fire).")])]), _c('h4', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _c('a', {
    attrs: {
      "id": "ch02lev2sec5"
    }
  }, [_vm._v("LEADERSHIP")])]), _c('a', {
    attrs: {
      "id": "ch02lev2sec5"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "ch02lev2sec5"
    }
  }, [_vm._v("Chapter 7 discusses leadership in depth, but the matter of leadership and how decisions will be made once out on the trail should be part of your expedition planning. Many people who go out on a trip don’t assign formal leadership roles. They make decisions through informal discussions and if there is a leader, he or she arrives at the position through some sort of organic process, not by a conscious and spoken group choice. That style may work well for teams that have traveled together before and have proven to work well together as a team. But when you travel in a large group or when ")]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("your trip becomes more involved—remote, big mountain expeditions, for instance—you are better off designating a leader. It is arguably better to designate a leader even for trips of small consequence. The leader needn’t make all the group’s decisions in an autocratic way, but in a crunch, such as a medical emergency, having an official leader could mean faster action. The leader’s role may include deciding whether or not to complete a route, planning an evacuation, moderating disputes, and boosting morale. The leader does not necessarily have to be the most experienced in the group, but he or she should be respected by all the members and have excellent judgment.")])]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("It may be a little awkward, but if you discuss how day-to-day decisions are going to be made before you leave for the wilds, you will likely have a more successful trip. On all but the most fortunate expeditions, there comes a time when two or more group members don’t agree on a matter large or small. If you agree in advance that the person leading that day will resolve the conflict or, on the other hand, that the decision will be made through consensus, you will save yourself the headache of coming up with an ad hoc plan out on the trail.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A trip with every minute and every decision mapped out in advance would be too rigid and would feel like a forced march; some flexibility is necessary to adjust to the mood, health, and desires of the group members. But a leader and a plan should be chosen in advance to deal with the less forgiving circumstances.")]), _vm._v(" "), _c('div', {
    staticClass: "sidebar"
  }, [_c('h3', {
    staticClass: "h3s"
  }, [_vm._v("Five Common Mistakes People Make in Planning and Completing an Expedition")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("• Not checking the crucial equipment such as the tent, stove, pack, and headlamp.")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("• Underestimating the time and effort it will take to hike the distances shown on the map.")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("• Planning to do too much on one trip and being overburdened by gear.")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("• Concentrating so hard on completing a route that they forget to enjoy the views, smells, and sounds along the way.")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("• Rushing out of the backcountry the last day and risking injury or separation from the group.")])])]), _c('h4', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _c('a', {
    attrs: {
      "id": "ch02lev2sec6"
    }
  }, [_vm._v("COMMITMENT TO THE TRIP AND THE DIVISION OF LABOR")])]), _c('a', {
    attrs: {
      "id": "ch02lev2sec6"
    }
  }), _c('p', {
    staticClass: "noindentb"
  }, [_c('a', {
    attrs: {
      "id": "ch02lev2sec6"
    }
  }, [_vm._v("It is a joy to travel with committed people. Such types troubleshoot sputtering stoves, make coffee on the miserable mornings, and catch meaty trout. Alas, those not committed spend lots of time in the tent (and take up lots of ")]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("space as well), show pouty faces when the trail gets steep, and have little nice to say about someone’s cooking. If you are going to commit good money and dear time to an expedition, better to know your companions feel the same sense of commitment. My friend Phil Powers, a NOLS instructor and highly accomplished mountaineer, suggests assigning planning tasks prior to leaving as a way to test commitment in the group. If, for example, you are traveling to the mountains for four days, have one member organize maps, another rations, and another transportation. If the person responsible for maps doesn’t lift a finger as the departure date nears, ask him directly if he wants to go on the trip. Here are a few ways you may want to divide the tasks:")])]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('p', {
    staticClass: "bull"
  }, [_vm._v("• Ration planning: This person organizes and buys all the food. He or she should poll the other members on likes, dislikes, and allergies. This is a big job so it might take two people.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Maps, routes, and regulations: This person buys all the maps, researches regulations, and plans the route. As she plans, she can stay in contact with the rest of the group to pose options and solicit ideas.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Transportation: If your trip is simple—a two-day backpack in the backyard wilderness—this job may not be necessary. But if you do something exotic, say a trek in Peru, the transportation planning may take phone calls, foreign language skills, trips to the travel agent, and other intricate and time-consuming tasks.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Equipment planning and revision: This job entails the organization and revision of major group gear including the tent, stove, kitchen utensils, and first aid kit.")])]), _c('h4', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _c('a', {
    attrs: {
      "id": "ch02lev2sec7"
    }
  }, [_vm._v("SHARING COSTS")])]), _c('a', {
    attrs: {
      "id": "ch02lev2sec7"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Camping needn’t be expensive but there are always costs—gas, food, maps, gear, etc. Find an equitable way to share the costs. If your buddy drives his rig, you pay for the gas. If your buddy brings his new tent, stove, and fishing gear, you spring for the maps. Keep it simple and agree upon it in advance.")])]), _c('h4', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "ch02lev2sec7"
    }
  }), _c('a', {
    attrs: {
      "id": "ch02lev2sec8"
    }
  }, [_vm._v("PHYSICAL CONDITIONING")])]), _c('a', {
    attrs: {
      "id": "ch02lev2sec8"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "ch02lev2sec8"
    }
  }, [_vm._v("Hiking long miles with a heavy pack is strenuous. Climbing the hills takes strong legs, and balancing the pack weight over tricky stretches on the trail takes a strong back. The men and women who spend their waking hours teaching outdoor education or tackling high mountains fairly ripple with muscle and sinew, the author notwithstanding. All things being equal, the ")]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("stronger you come into your trip, the more fun you’ll have, the more you’ll achieve, and the safer you’ll be.")])]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("A detailed plan is beyond the scope of this book, but the basics are worth mentioning. You don’t have to train with the intensity of a marathoner before your trip but try to train for a few weeks prior to leaving. Your regimen should include three components: flexibility training, resistance training, and cardiovascular training.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Developing flexibility before you go will reduce the chances of injury and will add to your agility. Find three or four stretches for the legs, and three or four for the trunk and arms. You can stretch just about anywhere—at the gym, in front of the TV, or at your desk. Out on the trail you may want to do a few stretches every morning as well, especially if you wake up sore and tight.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Resistance training builds muscle mass, which will give you more power and help prevent injuries. You want resistance training that strengthens the entire body. You can do resistance training with weight machines or using your own body weight. Double knee bends (not beyond 90 degrees, please), one-legged knee bends, push-ups, sit-ups, chin-ups, trunk lifts, and weight lifting are all good forms of resistance training.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There are many ways to build your cardiovascular level depending on where you live, your preferences, and how much free time you have. The most obvious and perhaps most logical activity to train for hiking trips is, well, hiking. If you live in a big city, this training may be impossible, but if you have access to the mountains on weekends or during the week, simply get out there and hike the most varied terrain you can find. Walking uphill will build leg strength on top of the cardiovascular conditioning. Walking downhill develops balance and leg strength as well. If you’re going to be carrying a heavy pack on your actual trip, you may as well carry a pack in your training. If you are out of shape, start very light—say with ten pounds—and then add five pounds per week until you reach the approximate weight you plan to carry on your trip. Bicycling, running, and swimming are other good forms of exercise for developing your heart and lungs.")])]), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _c('a', {
    attrs: {
      "id": "ch02lev1sec2"
    }
  }), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("Expedition Goals")])]), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _c('h4', {
    staticClass: "h4a"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _c('a', {
    attrs: {
      "id": "ch02lev2sec9"
    }
  }, [_vm._v("OBJECTIVES AND EXPEDITION PHILOSOPHY")])]), _c('a', {
    attrs: {
      "id": "ch02lev2sec9"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "ch02lev2sec9"
    }
  }, [_vm._v("In 1939, seven Americans set out to climb K2, considered by many to be the most difficult mountain in the world."), _c('sup', {
    staticClass: "sup"
  })]), _c('a', {
    attrs: {
      "href": "#/xhtml/#ch02fn1",
      "id": "ch02-fn1"
    }
  }, [_vm._v("I")]), _vm._v(" K2 had never been climbed before. The expedition was led and organized by Fritz Wiessner, a formidable mountaineer already famous for his first ascents on the southeast face of the Fleish-bank of the Austrian Tyrol and the north face of the Furchetta in the Dolomites. Wiessner’s team consisted of some of the most qualified American mountaineers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Some two months after the Americans began the climb, three members of the expedition were dead, several others were injured or sick, no one had reached the summit, and certain members of the party parted mortal enemies. It would be unfair to cast harsh judgment on the brave attempt and the competent men who nearly summited K2 in 1939, but we do have the hindsight to see that their disparate expedition objectives and philosophies likely contributed to the harrowing results.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One of the main problems cited by observers among the American alpine community was the difference in climbing philosophy and leadership style between Wiessner and the rest of the team. Wiessner, a German immigrant, “. . . had been reared in the school of absolute obedience to authority that characterizes much of the teutonic ethos: the leader leads and the troops obey, whatever the situation.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02fn2",
      "id": "ch02-fn2"
    }
  }, [_vm._v("II")])]), _vm._v(" His American team, by contrast, was used to more democratic methods of making decisions. As a result, Wiessner did not perfectly understand his team, nor they him. What seemed open communication to the Americans seemed like insubordination to Wiessner. What seemed unreasonably dangerous to the Americans, Wiessner considered a necessary risk in extreme mountaineering.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ultimately, Wiessner and a teammate named Dudley Wolfe became separated from the rest of the Americans by several camps and several thousand vertical feet. Only Sherpas, who did not speak English, bridged the gap between Wiessner and Wolfe above, and the rest of the team below. Late in the expedition when the team below lost contact with Wiessner for a full eight days, they assumed he had perished. They decided to dismantle the intermediate camps. This would prove fatal for Wolfe and nearly fatal for Wiessner, who later accused the others of attempted murder.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("One might think that climbing a big mountain like K2 would simply and automatically define the expedition goals. But as the story shows, expedition goals and philosophy can be more subtle and complex. An expedition goal is not just getting from point A to point B or climbing peak X. Expedition goals include where you go but also how you go and even why you go. It’s important that everyone on your trip be included in defining the expedition goals. When a person contributes his thoughts and ideas on what direction a trip should take, he will feel more ownership for the outcome and will likely take more responsibility in ensuring that the goals are achieved.")])]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("A few years ago, when I climbed Argentina’s Aconcagua with a couple of friends, we determined that our expedition goals centered around having some fun, traveling safely, eating well, and maintaining our friendships. Our inventory of gear included ropes and ice axes but also a three-pound spice kit and three books each: The summit was an important goal to us but not at all costs. Our route up Aconcagua was too modest even to be mentioned on the same page as Wiessner’s feats, but no matter how modest the route, the three of us left Argentina with a good, worthwhile experience behind us, due in part to our shared objectives and philosophies. Having traveled and worked together before we started the trip, we already knew that our philosophies jibed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It’s quite possible that your gang will start a trip with what you think are common objectives and philosophies, only to discover that you don’t see eye to eye. A friend of mine tells the story of a trip she made to the then Soviet Union to do a joint American-Soviet expedition in Kazakhstan. The purpose of the trip was to share scientific expertise, share cultures, and enjoy the mountains. Friction between the two groups developed immediately when members of the American group set out to climb a small peak near the first camp. The Soviets did not like the idea of any travel, no matter how small the trip, without the express permission of the Soviet trip leader. The independent-minded Americans bristled at the infringement on their freedom. Ultimately, the Americans realized that they had to live with the Soviet rules, and the group settled into the business of making a successful expedition.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Common objectives and philosophies do not guarantee a smooth, happy trip. But they certainly increase your odds. It’s possible that your group will start with the same objectives but during the trip, time and circumstances will change individuals’ aims. When that becomes apparent, it’s time to sit down, hash it out, and possibly redefine the what, how, and why of your trip.")])]), _c('div', {
    staticClass: "sidebar"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _c('h3', {
    staticClass: "h3s"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("Tips on Planning Your Route")])]), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_c('p', {
    staticClass: "noindents"
  }, [_vm._v("• "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("Mileage")]), _vm._v(" The average backpacker can travel from 5 to 10 miles per day over moderate terrain with a full pack.")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("• "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("Terrain")]), _vm._v(" The terrain and condition of the trails affects your pace. Add about an extra hour to your day for every 1,000 vertical feet you climb.")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("• "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("First Days Out")]), _vm._v(" Your first days out you will likely be getting used to your pack, your boots, and the strenuous exercise. If you haven’t been out in a while, better to make your first day or two light work.")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("• "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("Rest Days")]), _vm._v(" On long or strenuous trips take a rest day every four to six days. Rest days are great opportunities to bake, fish, climb peaks, and just plain rest. Be flexible with your itinerary to take advantage of the best spots or the best times for your breaks.")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("• "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("Alternatives")]), _vm._v(" When planning your route, look for alternatives to shorten or lengthen your route. For instance, if you plan a 50-mile loop, there may be a shortcut that knocks off 10 miles should you get behind, or a detour that adds 10 miles if you’re feeling particularly strong.")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("• "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("Avoiding the Crowds")]), _vm._v(" Avoid peak seasons and the most popular trails if you want to get away from it all. Travel midweek if you can. The early fall can also be a great time to avoid crowds.")])])]), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _c('a', {
    attrs: {
      "id": "ch02lev1sec3"
    }
  }, [_vm._v("Route Planning")])]), _c('a', {
    attrs: {
      "id": "ch02lev1sec3"
    }
  }), _c('h4', {
    staticClass: "h4a"
  }, [_c('a', {
    attrs: {
      "id": "ch02lev1sec3"
    }
  }), _c('a', {
    attrs: {
      "id": "ch02lev2sec10"
    }
  }, [_vm._v("YOUR ROUTE")])]), _c('a', {
    attrs: {
      "id": "ch02lev2sec10"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Good route planning is an art born of lots of experience, a bit of diligence on the planner’s part, and a little luck. It’s one thing to march from point A to point B on a superhighway trail described in a dozen guidebooks. It’s quite another to creatively link various river valleys and mountain passes into an interesting loop. If you take the time to study the area you’re visiting before your trip, you may avoid unpleasant surprises—trail closures, poor fishing, snowdrifts that stop your horse resupply or your car en route to the trailhead, etc.—and might even learn something that improves your trip.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Once you have chosen the area, find a huge table or a clear floor space, arrange your maps, and do some finger walking across your route. Every seasoned camper has calibrated some bodily part to trace distance, whether it’s a finger or a few knuckles. Trace out your first day’s mileage—whether it’s five miles or 15 miles—and see where that puts you for a camp. Is there a water source? Does the terrain look flat enough to camp comfortably? Where would you camp if you didn’t make it to that camp? Taking a mental hike over the maps in front of you, while trying to consider mileage, difficulty of terrain, possible vistas, rest days, fishing holes, shortcuts, evacuation routes, etc., is the best way to plan your route. Bring a fellow traveler in at this stage: Two heads are better than one.")])]), _c('div', {
    staticClass: "sidebar"
  }, [_c('a', {
    attrs: {
      "id": "ch02lev2sec10"
    }
  }), _c('h3', {
    staticClass: "h3s"
  }, [_c('a', {
    attrs: {
      "id": "ch02lev2sec10"
    }
  }), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("Regulations That Can Affect Your Trip")])]), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_c('p', {
    staticClass: "noindents"
  }, [_vm._v("• Fire: Certain areas become too volatile for fires during droughts. "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("t")]), _vm._v(" Group size limit")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("• Bear camping: You may be required to hang your food and practice special bearcamping techniques in areas thick with bears.")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("• Restricted camping areas: Managers restrict areas to protect wildlife or to allow heavily damaged areas to recover.")])])]), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }), _c('h4', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }), _c('a', {
    attrs: {
      "id": "ch02lev2sec11"
    }
  }, [_vm._v("REGULATIONS")])]), _c('a', {
    attrs: {
      "id": "ch02lev2sec11"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Nearly all public lands have regulations that will affect your trip. In a dry year, land managers may ban open fires. In heavily used areas, managers may prohibit camping in places with delicate or recovering vegetation. If you’re camping in bear country, you may be required to “bear camp” (see Chapter 5) as prescribed by the agency. Many places have restrictions on group size.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The best place to call to get information on these regulations is the local office of the very agency in charge of the land where you plan to travel. If you plan to hike in Colorado National Monument, for instance, call the National Park Service in Fruita, Colorado. If you plan to hike in the Maroon Bells-Snowmass Wilderness Area, call the White River National Forest supervisor.")])]), _c('h4', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "ch02lev2sec11"
    }
  }), _c('a', {
    attrs: {
      "id": "ch02lev2sec12"
    }
  }, [_vm._v("MAPS")])]), _c('a', {
    attrs: {
      "id": "ch02lev2sec12"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("After deciding where to go, you need to collect all the maps that your route crosses as well as the maps adjacent to your route. We will talk about maps in depth in Chapter 8. Generally the best maps for hiking in the United States are 7.5 minute series United States Geological Survey (USGS) topographical maps. These maps are of such a scale to give you lots of detail on the terrain. The disadvantage of maps of this scale is that you have to spread out several together to get a bigger picture of the whole route. If you’re doing a trip of any consequence—let’s say more than 50 miles of travel—bring a map that shows the bigger picture as well as 7.5 minute series maps. The USGS and private companies like Trails Illustrated (see sidebar on the following page) make maps drawn to a scale of 1:250,000.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("How many sets of maps you bring depends on the number of people in your group, but having two sets makes sense with three or more people. On a rest day, you may decide to climb a peak while your friends descend a valley to go fishing. The extra maps give you the flexibility to do just that. What’s more, in the event of an emergency, one set of maps can go with the party going for help while the other set remains with the party that stays with the injured.")])]), _c('div', {
    staticClass: "sidebar"
  }, [_c('a', {
    attrs: {
      "id": "ch02lev2sec12"
    }
  }), _c('h3', {
    staticClass: "h3s"
  }, [_c('a', {
    attrs: {
      "id": "ch02lev2sec12"
    }
  }), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_vm._v("Map Sources")])]), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_c('h4', {
    staticClass: "h4s"
  }, [_vm._v("UNITED STATES")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("• "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("United States Geological Survey (USGS)")]), _vm._v(" The USGS is the nation’s largest map source and produces detailed topographical maps of nearly the entire country. This agency is a good starting point for your maps. The USGS also publishes a free “Map Index” for every state.")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("USGS Information Services")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Box 25286")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Denver, CO 80225")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("800-USA-MAPS")])]), _c('p', {
    staticClass: "noindents"
  }, [_c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_vm._v("Web site: ")]), _c('a', {
    attrs: {
      "href": "http://mapping.usgs.gov",
      "target": "_blank"
    }
  }, [_vm._v("http://mapping.usgs.gov")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentts"
  }, [_vm._v("• "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("National Park Service (NPS)")]), _vm._v(" Maps of all national parks")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("NPS, Room 1013")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Washington, DC 20240")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("202-208-4747")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Web site: "), _c('a', {
    attrs: {
      "href": "http://www.nps.gov",
      "target": "_blank"
    }
  }, [_vm._v("http://www.nps.gov")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentts"
  }, [_vm._v("• "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("U.S. Forest Service (USFS)")]), _vm._v(" Maps of all the national forests USFS, Public Affairs Office, 2nd Floor, Auditor’s Building 14th and Independence Avenue S.W., Washington, DC 20250")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("202-205-1760")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Web site: "), _c('a', {
    attrs: {
      "href": "http://www.fs.fed.us",
      "target": "_blank"
    }
  }, [_vm._v("http://www.fs.fed.us")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentts"
  }, [_vm._v("• "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("Trails Illustrated")]), _vm._v(" Maps printed on high quality tearproof, waterproof paper-like plastic. Each map usually covers eight or nine 7.5 minute quadrangles. They make excellent overview maps of your entire route.")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Trails Illustrated")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("P.O. Box 4357")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Evergreen, CO 80437")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("800-962-1643")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Web site: "), _c('a', {
    attrs: {
      "href": "http://www.wildfur.com/trails/trailhead.html",
      "target": "_blank"
    }
  }, [_vm._v("http://www.wildfur.com/trails/trailhead.html")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentts"
  }, [_vm._v("• "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("Your Local Camping or Mountaineering Store")])]), _vm._v(" "), _c('h4', {
    staticClass: "h4s"
  }, [_vm._v("CANADA")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("• "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("Canada Map Office")]), _vm._v(" National Topographic Series of maps covers all of Canada’s provinces and territories. This agency also has maps of Canada’s national parks.")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("615 Booth Street")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Ottawa, Ontario Kl A 0E9")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("613-952-7000")]), _vm._v(" "), _c('h4', {
    staticClass: "h4s"
  }, [_vm._v("FOREIGN")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("• "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("Europe Map Service/OTD Ltd.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("1 Pinewood Road")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Hopewell Junction, NY 12533")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("914-221-0208")]), _vm._v(" "), _c('p', {
    staticClass: "noindentts"
  }, [_vm._v("• "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("The Map Store")])]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("5821 Karric Square Dr.")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Dublin, OH 43017")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("800-332-7885")])]), _vm._v(" "), _c('div', {
    staticClass: "inline_group"
  }, [_c('img', {
    staticClass: "landscape_60",
    attrs: {
      "alt": "image",
      "src": "images/f0046-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_vm._v("On trips longer than eight or nine days, you’ll need a way to resupply your food. Horsepackers are a good option in certain western states because they can bring your rations to you deep in the backcountry. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Mark Harvey")])])]), _c('a', {
    attrs: {
      "id": "page_46"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }), _c('h4', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "page_46"
    }
  }), _c('a', {
    attrs: {
      "id": "ch02lev2sec13"
    }
  }, [_vm._v("RESUPPLYING YOUR TRIP")])]), _c('a', {
    attrs: {
      "id": "ch02lev2sec13"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("If you plan to travel for more than a week, you will probably need to resupply food, fuel, and perhaps first aid supplies. Seven to ten days of food and fuel seems to be the limit for most backs to carry. You can use your resupplies to bring in other things too. For example, you may do a route that involves just hiking on the first half and then rock climbing on the second half. Rather than carry all your climbing gear the entire trip, you can arrange to have it carried in on a resupply.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What means you choose to resupply your trip depends, of course, on where you go. If your trip takes you through areas with accessible roads, you might simply have a friend drive supplies to an agreed-upon trailhead. In Alaska you might need a boat or plane. In Chile, NOLS has even used ox carts.")])]), _c('p', {
    staticClass: "noindentl"
  }, [_c('a', {
    attrs: {
      "id": "ch02lev2sec13"
    }
  }), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Quick and Easy Ways to Resupply Your Trip")])])]), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_c('p', {
    staticClass: "bull"
  }, [_vm._v("• Mail your food via general delivery to a post office that intersects or is adjacent to your route. Mark a to-be-picked-up-by date in case you don’t make it that far in your trip.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Have a friend meet you at an agreed-upon trailhead.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Make a loop that returns you to your own car or a second car down the trail.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentl"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Resupplying Using Horses")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If you’re camping in the West, your best bet for a resupply may be with a horse. Horsepackers can handle the oddest loads—from lawn chairs to hay bales—and the sheer size, strength, and agility of a horse gives you the flexibility to haul your food and gear deep into the wilderness. Consult with the packers and they can tell you how they want you to package your supplies. If you have odd-shaped, fragile, or pointy items such as ice axes, photography gear, or weather balloons, tell your packer in advance.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Some horsepackers will buy your fresh produce for you so it doesn’t have to sit around wilting for a week. If that’s not possible, check to see if they have refrigeration at their barn.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("While horses can cross nearly any terrain that a person on foot can handle, keep the following in mind when choosing your resupply site:")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Horses have difficulty crossing steep snow slopes or partially melted snowfields. If you are traveling in the late spring or early summer and don’t know the snow conditions, either plan your resupply for lower elevations or plan a contingency site in case there is too much snow at the original site.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Your best option may be to let the packer select the resupply site. If he has a regular spot that works with your route, you may save money on the trip. The other advantage to letting the packer choose the site is that he will choose a site that can accommodate his string of horses.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentl"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Resupplying Using Aircraft")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the wilds of Alaska’s Brooks Range, British Columbia, or Chile’s Patagonia, you may choose a route that has no road crossings or nearby horse ranches. When that’s the case, your only option for a resupply may be by plane or helicopter. Remember that in most wilderness areas, using motorized aircraft is illegal except with special permission in emergency evacuations.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_vm._v("A Piper Super Cub airplane costs about $150 per hour, but it can only carry ")]), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_vm._v("about 200 to 300 pounds, depending on the condition of the airstrip, the weather, and the travel time from the hangar to the ration site.")])]), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Helicopters can fly nearly anywhere for a price—yes, for a very hefty price indeed. But if there’s no airstrip or the visibility is poor, that may be your only option. Since helicopters can usually handle a bigger payload than a small plane, they are sometimes more cost effective than planes. Helicopters can handle worse weather than their fixed-wing counterparts and land in tighter spots. In short, they are more versatile than fixed-wing airplanes. Depending on the make of the helicopter and the company, you will pay between $400 and $600 per hour.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If you hire a helicopter to do your resupply, keep in mind that the helicopter pilot may choose his landing site only once he sees the area for himself. The site you choose for him may not be the best site so be prepared to move in a hurry.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Regardless of whether you use a helicopter or a fixed-wing plane, the weather will ultimately determine whether or not your pilot can deliver your groceries. Bush pilots have a deserved reputation for their courage in flying in bad weather and in tight spaces. But have a contingency plan in case the weather makes it impossible for your pilot to land. Several friends of mine have waited three days or longer for a break in the Alaska weather so the plane could deliver the groceries.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("No matter the method you choose to resupply your trip, you want a site you can comfortably reach on the scheduled day. For instance, if you plan to re-ration on the seventh day of your trip and have scheduled 100 miles of hiking to that site, you might miss your re-ration or run out of food before you get there.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If you do use a third party to resupply your trip and have arranged to meet at an agreed-upon location, be sure to give your resupplier instructions as to where he should leave your supplies if you do not arrive on time.")])]), _c('h4', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "page_48"
    }
  }), _c('a', {
    attrs: {
      "id": "ch02lev2sec14"
    }
  }, [_vm._v("USING YOUR COMPUTER IN PLANNING YOUR EXPEDITION")])]), _c('a', {
    attrs: {
      "id": "ch02lev2sec14"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "ch02lev2sec14"
    }
  }, [_vm._v("If you have a computer, a modem, and Internet access, you can find lots of valuable information to help you plan your route, purchase equipment, and even seek advice on the area where you’re going. Several government agencies, equipment manufacturers, and outdoor clubs have helpful Web sites. For instance, the Army Corps of Engineers, the Bureau of Land Management, the Bureau of Reclamation, the Fish and Wildlife Service, the Forest Service, and the National Park Service have joined together to create a site ")]), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_vm._v("called “")]), _c('a', {
    attrs: {
      "href": "http://Recreation.gov",
      "target": "_blank"
    }
  }, [_vm._v("Recreation.gov")]), _vm._v("” ("), _c('a', {
    attrs: {
      "href": "http://www.recreation.gov",
      "target": "_blank"
    }
  }, [_vm._v("http://www.recreation.gov")]), _vm._v("), which offers all sorts of information about specific recreation sites, phone numbers, weather, and overview maps. I live in Colorado so, for the hell of it, I went to the "), _c('a', {
    attrs: {
      "href": "http://Recreation.gov",
      "target": "_blank"
    }
  }, [_vm._v("Recreation.gov")]), _vm._v(" site and did a search on the Alamosa area. The site offered a description and pictures of the Alamosa National Wildlife Refuge, up-to-the-hour weather information, and several “hyperlinks,” which, for those of you new to the Internet, are connections to related sites. One of the hyperlinks for the Alamosa National Wildlife Refuge is the “Avian Page,” which lists the bird migration there and tells me that they recently sighted a golden-winged warbler near Alamosa for the first time ever, not to mention three double-crested cormorants!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Another useful site is the one maintained by the National Weather Service ("), _c('a', {
    attrs: {
      "href": "http://iwin.nws.noaa.gov",
      "target": "_blank"
    }
  }, [_vm._v("http://iwin.nws.noaa.gov")]), _vm._v("), which offers local, national, and international forecasts. They of course have hyperlinks, one of which is a weather glossary. Did you know that the word “scud” means “small, ragged, low cloud fragments that are unattached to a larger cloud base and are often seen with and behind cold fronts and thunderstorm gust fronts”? You’ll find that term and others on the National Weather Service weather glossary.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If you wanted to hike the Pacific Crest Trail and needed a partner to do it, you could check out "), _c('a', {
    attrs: {
      "href": "http://saffron.hack.net/lists/",
      "target": "_blank"
    }
  }, [_vm._v("http://saffron.hack.net/lists/")]), _vm._v(", a Web page dedicated to national scenic trails. On that page, I found people looking for partners to do various sections of the trail, tips on equipment, route suggestions—if the Baden-Powell section is too snowy, take the Manzanita Trail—and querulous essays disparaging certain government agencies managing sections of the Pacific Crest Trail.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If you’re interested in taking a NOLS course, visit the NOLS Web site at "), _c('a', {
    attrs: {
      "href": "http://www.nols.edu",
      "target": "_blank"
    }
  }, [_vm._v("http://www.nols.edu")]), _vm._v(". The site lists dates and descriptions of the various NOLS courses, a list of NOLS publications, and information on how to contact the school.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There are millions of Web pages on the Internet, some of them extremely useful, some perfectly useless, and some merely amusing. But if you learn to focus your searches with Boolean commands (talk to your computer geek friend about that), you can use your computer and modem as a powerful tool to plan your expedition.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "ch02lev1sec4"
    }
  }, [_vm._v("Contingency Plans")])]), _c('a', {
    attrs: {
      "id": "ch02lev1sec4"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "ch02lev1sec4"
    }
  }, [_vm._v("When NASA planned the Apollo missions to the moon in the sixties, they had to make contingency plans based on the unknown. No one had ever landed ")]), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_vm._v("a spaceship on another planet and there was no way of knowing for sure what might go wrong. All the scientists could do was imagine what might fail and plan backup systems based on their educated guesses. Drawing a parallel between your trip to the backcountry and a trip to the moon may be labored, but there are some useful analogies. When you go to the backcountry, you leave a very organized system that you know backward and forward for a system with less infrastructure and more of the unfamiliar. You can make educated guesses about what might go wrong in the wilds, but there are many unknowns, which you simply can’t anticipate with any consistency, especially if you’re going to a new area. But that’s no reason to throw your hands up in despair and say, “We’ll just deal with the problems when they arise.” You can make sound contingency plans for your expedition by considering both the typical ways in which people get in trouble in the back-country and the particular vulnerabilities of your group.")])]), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Contingency planning is an exercise in imagining the unimaginable. You can start by asking yourself what you would do if one of your party members became sick or injured. Types of injuries you might expect in the outdoors include sprains, broken bones, dislocations, lacerations, frostbite, hypothermia, and hyperthermia. Illnesses include gastrointestinal sickness caused by bacteria or viruses as well as diseases caused by bites or stings from local fauna. It is unlikely that someone on your trip through the Green Mountains of Vermont will break his femur, but it’s not impossible. It is unlikely that someone on your trip to the mountains of Baja California will get bit by a rattlesnake, but also not impossible. To be prepared for contingencies, then, you should know at least rudimentary, and, preferably, advanced first aid.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_vm._v("A good contingency plan also calls for knowing when and how to evacuate a person in the event of a serious injury or illness and what outside assistance is available. These skills require training not just in first aid, but in "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("wilderness")]), _vm._v(" first aid. Understanding the communication systems in the area where you take your trip is also an important element in a contingency plan. By communication systems, I mean everything from trails, roads, and locations of pay phones that can be used by an evacuation team, to electronic devices such as cell phones and radios. When you spread out your maps to plan your route, take note of the surrounding areas, geographical features, roads, and townships. You may plan a simple route that takes you up to a lake and back over a period of five days. Were someone to be seriously injured at the lake, the shortest route for help might be in the opposite direction from where you came. Perhaps you see the symbol for a building on your map ")]), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_vm._v("fewer than five miles from the lake. In your planning it’s worth finding out if that building is the remains of a ghost town or an active ranch. Making a few phone calls to land management agencies, the local sheriff, search and rescue groups, outfitters, and local clubs and talking to local sports shops can really help you to understand the available communication systems and thereby make a better contingency plan. It’s worth bringing along the maps that show you alternative routes out of the backcountry.")])]), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }), _c('h4', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "page_51"
    }
  }), _c('a', {
    attrs: {
      "id": "ch02lev2sec15"
    }
  }, [_vm._v("RADIOS, CELL PHONES, AND OTHER ELECTRONIC COMMUNICATION DEVICES")])]), _c('a', {
    attrs: {
      "id": "ch02lev2sec15"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Radios, cell phones, and other electronic communication devices can be very useful in the case of emergencies. NOLS courses around the world utilize a wide variety of electronic communication devices, including many different types of radios and cell phones. If you wish to use these tools, it is important to understand their limitations, which may include weight, expense, range, battery life, licensing regulations, and durability. The danger with carrying a phone or a radio is that it can give people a false sense of security and cause them to forget the remote setting and the complicated logistics of an evacuation. Climbers and backpackers armed with cell phones have called mountain shops for directions from the backcountry. Parties have called 911 for help with problems that they obviously should have been prepared for. In these cases, the phones and radios acted as a crutch that kept the parties from relying on themselves and planning their expeditions with more care. If you do carry a radio, it’s important that you not let it prevent you from being self-sufficient and safe.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Don’t assume that your cell phone or radio will work everywhere in the world. Remember that to make a connection with a cell phone you need to be within range of a “cell site” and there are lots of “holes” over the wilderness areas. If you bring a ground-to-air radio to a place where there are no overhead flights—parts of Alaska, for instance—it will be no more useful than trying to communicate with your hands cupped around your mouth and bellowing for help.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The choice of whether to bring a radio or not is a personal one. If you are traveling with a large group in an institutional setting, the argument for bringing a radio is strong—even if only for liability concerns. In small private groups, a radio may help cut a day off an evacuation. If you decide to carry a radio, know how to use it, when to use it, and its limitations.")])]), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "ch02lev2sec15"
    }
  }), _c('a', {
    attrs: {
      "id": "ch02lev1sec5"
    }
  }), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_vm._v("Ration Planning")])]), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The only thing certain in ration planning is that if you don’t bring enough food, you’ll likely find yourself eating something disgusting when the rations run out. NOLS instructor Andy Cline tells of the time he ran out of food deep in the southern Andes on a month-long hiking trip. He and his friends had the good fortune to find a remote farm and a farmer willing to sell them a lamb. They lived off the best parts of the lamb for a few days—the loins and the ribs—but soon they were into the less appealing parts—the brains, intestines, liver, and gonads. Competent mountaineers all, but sorely lacking in the study of nutrition, they devoured the liver with the result that their skins turned a ghastly orange from the near-toxic concentrations of vitamin A. Finally, they made brain soup. If the story has no moral instruction, it is nevertheless scientific proof that eating the brains of another animal does very little to improve the human intellect.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The movies always depict the lost traveler eating rich meals off the land— pheasant eggs, fresh salmon, ripe blackberries—when they run out of food, but unless you’ve really learned how to scavenge, you’ll go hungry.")])]), _c('h4', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "page_52"
    }
  }), _c('a', {
    attrs: {
      "id": "ch02lev2sec16"
    }
  }, [_vm._v("STAPLE FOOD VERSUS FREEZE-DRIED FOOD")])]), _c('a', {
    attrs: {
      "id": "ch02lev2sec16"
    }
  }, [_c('p', {
    staticClass: "noindentb"
  }, [_vm._v("When you plan your rations for the outdoors, you can either take staples such as pasta, flour, dried beans, rice, sugar, etc., or you can take specially prepared camping food like freeze-dried meals or boil packets. In general, we recommend staple food for a few reasons:")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• It’s much cheaper. A freeze-dried dinner listed as a meal for two costs between five and seven dollars. In my experience these meals really feed only one person. And for that money, you could easily pay for an entire day’s worth of staple food.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• It’s easier to find. Whether you’re traveling in the United States or in Bolivia, it’s easier to find something like pasta or potatoes than it is to find high-quality freeze-dried food.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• It allows you more flexibility. With staple food you can mix and match ingredients to your heart’s desire and, with a little effort, cook delicious meals. With prepackaged food, you are limited to the company’s choice of meals—a sort of carte fixe.")])]), _c('p', {
    staticClass: "indentt"
  }, [_c('a', {
    attrs: {
      "id": "ch02lev2sec16"
    }
  }), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_vm._v("Let’s not dismiss freeze-dried meals out of hand. The truth is freeze-dried meals have their place in your quiver of tricks. They weigh less than staple food. If you need to travel great distances and can’t arrange a resupply or cache, you can carry freeze-dried meals. What’s more, they are convenient. To prepare most freeze-dried meals, you simply add hot water. On demanding routes, easy-to-prepare meals make it that much easier to concentrate on the tasks at hand. If you’re climbing a major mountain, for instance, you may not want to think about cooking. You may have enough to concentrate on with the weather, the altitude, and the long days. Perhaps you’re not the type who likes to cook. Perhaps you’re eighty years old and limited to a small pack weight. What’s more, some companies have developed tasty freeze-dried meals.")])]), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }), _c('h4', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "page_53"
    }
  }), _c('a', {
    attrs: {
      "id": "ch02lev2sec17"
    }
  }, [_vm._v("TYPES OF STAPLE FOODS")])]), _c('a', {
    attrs: {
      "id": "ch02lev2sec17"
    }
  }, [_c('p', {
    staticClass: "noindentl"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Trail Foods")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Nuts and Seeds.")]), _vm._v(" Nuts such as peanuts, almonds, cashews, Brazil nuts, and walnuts, and seeds such as sunflower seeds and sesame seeds are high in energy, fat, and protein, make good trail food, and add nice texture and flavor to things like pancakes, dinner dishes, and breads. Buy the shelled nuts so you don’t have to pack out more garbage.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Dried Fruit.")]), _vm._v(" Dried peaches, apples, apricots, plums, pineapples, and raisins are high in carbohydrates and fiber. They make a good snack but can also be soaked in warm water and rehydrated to use in dessert dishes such as cobblers or dinner dishes such as curries. The sulphured fruits last longer than the fruits processed naturally.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Energy Bars and Fruit Bars.")]), _vm._v(" Several companies such as Power Bar and Cliff Bar make high-energy snacks loaded with complex carbohydrates, vitamins, and minerals. They’re expensive but simple snacks that give a great deal of energy. Drink lots of water with these so they digest properly. Halvah bars and pemmican bars are other good options for high-energy blasts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Breadstuffs.")]), _vm._v(" On short trips or if eaten early on long trips, it’s nice to bring hearty breads such as bagels or pita bread. They go well with cheese or peanut butter, can be fried with cheese for a breakfast, or eaten as a side with dinner. Bagels and pita bread will withstand the rigors of backpacking better than regular bread. Rye crisp, melba toasts, bagel chips, pretzels, zwiebacks, and the like are also durable and good with cheese.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Trail Mixes.")]), _vm._v(" You can buy or make your own trail mixes from a wide variety of snacks. Try nuts, raisins, M&Ms, dried fruit, crackers, banana chips, and whatever else suits your fancy.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ch02lev2sec17"
    }
  }), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Jerky and Salami.")]), _vm._v(" I like to make my own elk and beef jerky for the trail. It’s a nice source of protein and, if prepared properly, will last on long trips. See Chapter 11 for how to make jerky. Salami lasts several days on the trail, though you should try to keep it cool.")])]), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Fruit Leathers.")]), _vm._v(" You can buy fruit leather commercially or make your own using a dehydrator. High in energy, it’s a good alternative to sweets.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentl"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Dinner Foods")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Pasta.")]), _vm._v(" Pasta is rich in complex carbohydrates, easy to prepare, can be made into any one of several delicious dishes, is inexpensive, travels well, and is almost universally liked. In short, it’s one of the best dinner staples you can bring—the uber-food. If you’re going on a long trip, bring a variety of styles—spaghetti, macaroni, and penne—and a few flavors—white, wheat, and spinach. Pasta makes a good breakfast too.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Rice.")]), _vm._v(" Like pasta, rice can be used as the base of several recipes. It’s a good source of carbohydrates and, prepared with beans, makes a complete protein. Except for the instant variety, rice takes longer to cook than pasta.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Other Grains.")]), _vm._v(" Couscous, a Middle Eastern staple food, cooks quickly and can be prepared with some of the same recipes you use to prepare pasta. Cooked with brown sugar and cinnamon, it makes a nice breakfast. Bulgur is a wheat product with a lot of fiber and texture. Use it in place of rice for some variety. Falafel, another Middle Eastern food, is made from ground chickpeas, yellow split peas, and lots of spices. It can be made into patties and fried for a savory dinner.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Legumes.")]), _vm._v(" Beans are the basis for lots of Mexican recipes, go well with rice, and are easy to cook. Bring the quick-cooking beans unless you have a pressure cooker or are willing to take the trouble to soak them. Lentils make nice soups but need soaking and lots of time to cook.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Potatoes.")]), _vm._v(" There are a few forms of dried potatoes: flakes, pearls, and dehydrated hash browns. With the flakes and pearls you can make an instant meal simply by adding hot water and something like a powdered soup base to flavor it. At the end of a hard day when you don’t have energy to cook, potato pearls and flakes may be just what you need for dinner. The dehydrated hash browns take a little longer to cook but can be enjoyed for breakfast or dinner.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Cheese.")]), _vm._v(" Cheese, if not left out in the sun too often, lasts a surprisingly long time out on a camping trip. Low-fat and hard cheeses last even longer. It is good for pizza, Mexican meals, breads, and more. It also makes a nice snack on the trail. Cheese is high in protein and fat.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Meats.")]), _vm._v(" If your packs aren’t too heavy, bring along a can of chicken or tuna ")]), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_vm._v("as a nice addition to pasta, rice, bulgur, beans, or couscous. Once opened, however, the meat should be consumed immediately so you don’t have problems with food-borne illnesses.")])]), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Soups and Bases.")]), _vm._v(" Miso, ramen, powdered soups, and bouillon don’t weigh much, and are inexpensive and very nice on a cold evening. They also make easy bases for sauces or good flavorings for a main dish. If someone on the trip has an upset stomach from the altitude or bacteria, a simple soup may be the best solution.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentl"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Breakfast Foods")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Cold cereals")]), _vm._v(" like granola, Grape-Nuts, and Cracklin’ Oat Bran can be eaten for a quick breakfast or as a snack out on the trail.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Hot Cereals.")]), _vm._v(" Oatmeal, cream of wheat, and seven-grain cereals define the word hearty. They make a good breakfast for a long day and are simple to prepare. Buy the instant versions so you don’t have to spend too much time cooking in the morning. You can add rehydrated dried fruit, nuts, cinnamon, and brown sugar to make these cereals a little more interesting.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Pancakes.")]), _vm._v(" If you have a little extra time—perhaps on a rest day—and plenty of stove fuel, pancakes add a certain civility to any outdoor breakfast. You can buy the ready-to-cook mixes, or make your own from flour, baking powder, milk, and salt. Make your syrup with a little melted butter and some brown sugar.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentl"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Baking Materials")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Flour, both white and whole wheat, can be used to make bread, pancakes, pizza crusts, and cinnamon rolls. White flour is good for making gravy or white sauces, as well as for dredging your trout.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cornmeal is, of course, the base for corn bread, but also for tortillas, chapatis, and the hot cereal, polenta. Fresh trout dredged in cornmeal, salt, and pepper, then fried in margarine is delicious.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Baking mix, such as Bisquick or your own homemade version, simplifies making pancakes, pizza crusts, and biscuits.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentl"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Beverages")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Fruit crystals (good for flavoring water)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Coffee and tea")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Instant cocoa")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Apple cider mix")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Powdered milk for cold cereals, baking, casseroles, or for a warm mug of milk before bed")])]), _c('p', {
    staticClass: "noindentl"
  }, [_c('a', {
    attrs: {
      "id": "page_55"
    }
  }), _c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("A Word on Fresh Foods")])])]), _c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Unless you have a good way to keep your food cool (below 40° F), bringing along fresh foods such as meat, poultry, fish, and dairy products is a bad idea because of the danger of spoilage. These types of fresh foods, if not stored properly, make perfect breeding grounds for wretched bacteria such as Campylobacter and salmonella, which can make you seriously ill. But if weight is not an issue, it’s nice to bring an onion, a few potatoes, or some other hardy vegetable that doesn’t spoil easily.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentl"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Herbs and Spices")])]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("Bringing along a few herbs and spices and knowing how to use them is the basis for good backcountry cooking. Finding the right combination and the right proportions of herbs and spices comes with brave experimentation and close study of the master chefs in your expedition. Begin by mastering a few simple combinations such as oregano, garlic, and basil. Here is a list of versatile herbs and spices for your trip. Pick and choose the ones that suit your fancy.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Basil is a green, leafy herb (green flakes in its dried form) that smells somewhat like licorice and mint. It goes well with tomato sauces, Italian dishes, and any kind of fresh trout.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Black pepper is the most versatile of the spices (in the Middle Ages, a pound of black pepper would buy a serf’s freedom) and can be put in any dish to pep it up. Some people even put a pinch of pepper in a fruit cobbler to bring out the cinnamon. For the brave ones, put a tiny bit in your hot chocolate. You’ll be surprised.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Cayenne powder, which looks like paprika, is made from the thin red peppers and is very hot—between 30,000 and 50,000 Scoville heat units (the Scoville system is a way for pepper growers to measure how hot chili peppers are; the banana pepper is rated at 0 Scoville units and the habañero is rated at 300,000 units). It only takes a pinch.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Cinnamon (made from the bark of the evergreen laurel tree) is brilliant in sweet rolls, pancakes, cobblers, Mexican dishes, curries, hot cider, and tea.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Cumin has a pungent, smoky flavor and goes well with curry, cinnamon, and cayenne. It is the basis for many Mexican dishes and a good addition to rice and soups. Cumin is also nice in corn bread. A little goes a long way.")])]), _c('p', {
    staticClass: "bull"
  }, [_c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_vm._v("• Curry is an Indian spice (actually made from a combination of as many as 20 different spices) with a bright yellow color. Curry dishes can be ")]), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_vm._v("made with rice, bulgur, lentils, and soups. Hot peppers and dried fruit such as raisins or apricots go well with curry.")])]), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_c('p', {
    staticClass: "bull"
  }, [_vm._v("• Dill is a member of the same family that includes caraway, cumin, and coriander. The name dill comes from the Norse word "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("dilla,")]), _vm._v(" which means to lull. Dill does indeed have a mild sedative effect. Dill goes well in breads, with fish, pasta, and soups. The more you cook dill, the less flavor it has, so add it toward the end.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Garlic comes in powder, flakes, and of course in fresh cloves. This herb makes an Italian dish Italian or a Mexican dish Mexican. Fresh garlic in the backcountry adds a refined touch to your meals. Simmer it in oil to bring out the flavor.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Mustard can be hydrated and used in salad dressings for the fresh greens you pick along the trail, with casseroles, beans, or pasta. If the mustard is too strong for your taste, try hydrating it with a little vinegar for a milder mix.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Salt. If your meal tastes flat, it is probably lacking in salt, the Viagra of spices.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Soy sauce, a salty product of fermented soybeans, goes well with rice dishes, pasta, and soups.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Vanilla, a member of the orchid family, was used by the Aztec Indians to flavor their chocolate. Vanilla is still good in hot chocolate, pancakes, puddings, and dessert cakes.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Vinegar adds a pungent taste to sweet and sour dishes and makes a nice salad dressing (with some oil).")])]), _c('h4', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "page_57"
    }
  }), _c('a', {
    attrs: {
      "id": "ch02lev2sec18"
    }
  }, [_vm._v("BRINGING THE RIGHT AMOUNT OF FOOD")])]), _c('a', {
    attrs: {
      "id": "ch02lev2sec18"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("It’s not easy to hit your food quantities dead on for long trips in the mountains, but unfortunately you don’t have a lot of room for error. If you bring too much, you have to hump a huge pack up the trail. If you don’t bring enough you may find yourself eating sheep brains. Our discussion here deals with staple food, not freeze-dried meals.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ch02lev2sec18"
    }
  }, [_vm._v("Over the years, the better minds who plan rations at NOLS have learned that the average person eats between 1.5 and 2.5 pounds of food per person per day out in the mountains, or between 2,500 and 4,500 calories. There is a 60 percent difference between 1.5 pounds and 2.5 pounds so the weights bear discussion. Consider what sort of eaters you have in your group. An adolescent requires near hourly feeding. Some people eat lightly regardless of size, while others seem to consume their body weight in food. If you’re camping with new people, be wary of those who say, “Don’t bring much for me, I eat ")]), _c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_vm._v("like a bird.” Perhaps they eat like a bird in the city but out in the hills, humping their pack over the miles, they probably eat like a ravenous emu. Besides, some birds eat their body weight in food every day.")])]), _c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("How much food you eat also depends on how strenuous a trip you plan. You’ll eat less food while hiking light days in the summer than you will ski mountaineering in January. You’ll eat more food on a climbing trip than you will on a fishing trip. The table below can help you to decide how much food to ration.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If you’re going for a short trip of five days or less, it’s easiest to just plan your ration meal by meal. Once you have put together your menu for the trip, it’s a good idea to weigh all the food and divide the total poundage by the total number of person-days to make sure your quantities are within reason. For instance, on a five-day trip with four people, you have a total of 20 person-days. If your crew is going on a typical backpacking trip, based on the table below, you would want to bring between 30 and 40 pounds of staple food. If your total poundage is over or under that number, you know you need to rethink your menu.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_vm._v("On longer trips, it may be too complicated to plan out every single meal. Claudia Pearson, author of "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("NOLS Cookery")]), _vm._v(" and rations manager at the NOLS Rocky Mountain branch, plans rations for literally thousands of people per year. She does her planning by calculating the number of person-days, multiplying that number by the pounds per day (1.5-2.5 pounds), and then breaking down that number into specific food groups based on the pie chart on ")]), _c('a', {
    attrs: {
      "href": "#/xhtml/ch02#page_60"
    }
  }, [_vm._v("page 60")]), _vm._v(". For instance, 4 people traveling for 10 days would need 80 pounds of food (assuming they decide to bring 2 pounds per person per day). Based on the pie chart, their menu would include 12.8 pounds of breakfast food, 17 pounds of trail food, 14.4 pounds of dinner food, 10.1 pounds of cheese, 5.33 pounds of sugar and fruit drinks, 5.9 pounds of flour and baking mix, 3.2 pounds of soups, bases, and desserts, and 11.2 pounds of milk, eggs, margarine, and cocoa.")]), _vm._v(" "), _c('p', {
    staticClass: "figcaption"
  }, [_c('a', {
    attrs: {
      "id": "ch2fig1"
    }
  }, [_c('span', {
    staticClass: "txbfit"
  }, [_vm._v("Figure 2-1 Ration Table*")])])]), _c('a', {
    attrs: {
      "id": "ch2fig1"
    }
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "linea"
  }, [_c('p', {
    staticClass: "tabh"
  })]), _vm._v(" "), _c('td', {
    staticClass: "linea"
  }, [_c('p', {
    staticClass: "tabh"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Average Wilderness Activities (Backpacking or Kayaking)")])])]), _vm._v(" "), _c('td', {
    staticClass: "linea"
  }, [_c('p', {
    staticClass: "tabh"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Strenuous Wilderness Activities (Snowcamping)")])])]), _vm._v(" "), _c('td', {
    staticClass: "linea"
  }, [_c('p', {
    staticClass: "tabh"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Very Strenuous Activities (Extreme Mountaineering)")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "line25"
  }, [_c('p', {
    staticClass: "tabno"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Pounds per person per day")])])]), _vm._v(" "), _c('td', {
    staticClass: "line25"
  }, [_c('p', {
    staticClass: "tabno"
  }, [_vm._v("1.5-2")])]), _vm._v(" "), _c('td', {
    staticClass: "line25"
  }, [_c('p', {
    staticClass: "tabno"
  }, [_vm._v("2-2.25")])]), _vm._v(" "), _c('td', {
    staticClass: "line25"
  }, [_c('p', {
    staticClass: "tabno"
  }, [_vm._v("2.25-2.5")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "line25"
  }, [_c('p', {
    staticClass: "tabno"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Calories per person per day")])])]), _vm._v(" "), _c('td', {
    staticClass: "line25"
  }, [_c('p', {
    staticClass: "tabno"
  }, [_vm._v("2,500-3,000")])]), _vm._v(" "), _c('td', {
    staticClass: "line25"
  }, [_c('p', {
    staticClass: "tabno"
  }, [_vm._v("3,000-3,700")])]), _vm._v(" "), _c('td', {
    staticClass: "line25"
  }, [_c('p', {
    staticClass: "tabno"
  }, [_vm._v("3,700-4,500")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "line100",
    attrs: {
      "colspan": "4"
    }
  }, [_c('p', {
    staticClass: "tabnos"
  }, [_vm._v("*Source: "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("NOLS Cookery")])])])])])])]), _c('div', {
    staticClass: "inline_group"
  }, [_c('a', {
    attrs: {
      "id": "ch2fig1"
    }
  }, [_c('img', {
    staticClass: "landscape_60",
    attrs: {
      "alt": "image",
      "src": "images/f0059-01.jpg"
    }
  })]), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "ch2fig1"
    }
  }), _c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_vm._v("Weighing staples. On long expeditions getting the ration weights just right keeps the group well fed without being overburdened by extra weight. NOLS groups use food scales to make sure they bring the right amount of staple food. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Theo Singelis")])])]), _c('a', {
    attrs: {
      "id": "page_59"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Rarely do you bring just the right amount of food. Chances are, you’ll come back with a little extra food, which isn’t a bad thing. You won’t have a refined sense of ration planning until you get some experience with it. If you camp often, you should make some notes on how much food you bring each trip and how that food fared. Did you stuff yourself every day and still come back with 10 pounds of extra food? Next time lop a few points off your equation. Did you finish your ration two days before the end of your trip and spend the last twenty miles on a spiritual fast that you neither wanted nor enjoyed? Next time jack up your ration calculation. Did you arrive at the road-head with but one dried apple in your pack, content and well fed? Bravo!")])]), _c('h4', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "page_59"
    }
  }), _c('a', {
    attrs: {
      "id": "ch02lev2sec19"
    }
  }, [_vm._v("PACKAGING YOUR FOOD")])]), _c('a', {
    attrs: {
      "id": "ch02lev2sec19"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("There’s no sense bringing all the paper, cardboard, and plastic packaging that most foods come in—it’s extra weight and often ends up as backcountry litter—so once you’ve bought all your rations, it’s best to repackage it in two-ply plastic bags. If you bring something that has special instructions for its preparation, clip it out and put it in the plastic bag. Be sure your plastic bags are of at least two-ply strength or you’ll likely have powdered milk or some such spill all over your belongings. Tie the bags with a "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("loose")]), _vm._v(" overhand knot (who wants to fiddle with a tightly clenched knot on a cold day?) and, if you like, mark the difficult-to-identify ingredients with an indelible marker to identify the contents. For liquids like soy sauce, cooking oil, and vinegar, the plastic nalgene bottles with the screw-tops work well. The wide-mouthed nalgene tubs are best for things like peanut butter and margarine.")])]), _c('div', {
    staticClass: "inline_group"
  }, [_c('a', {
    attrs: {
      "id": "ch02lev2sec19"
    }
  }), _c('p', {
    staticClass: "figcaption"
  }, [_c('a', {
    attrs: {
      "id": "ch02lev2sec19"
    }
  }), _c('a', {
    attrs: {
      "id": "ch2fig2"
    }
  }), _c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_c('span', {
    staticClass: "txbfit"
  }, [_vm._v("Figure 2-2 Staple Food Pie Chart")])])]), _c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_c('img', {
    staticClass: "landscape_90",
    attrs: {
      "alt": "image",
      "src": "images/f0060-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_60"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_60"
    }
  }), _c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_vm._v("Finally, let me give you one of NOLS’s best trade secrets—nylon zip bags. Since you have to get at your food every day, you want a bag that gives you easy access. Nylon zip bags allow you to see and get at your victuals with ease.")])]), _c('a', {
    attrs: {
      "id": "page_61"
    }
  }), _c('h4', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "page_61"
    }
  }), _c('a', {
    attrs: {
      "id": "ch02lev2sec20"
    }
  }, [_vm._v("FUEL CALCULATIONS")])]), _c('a', {
    attrs: {
      "id": "ch02lev2sec20"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Calculate the quantity of fuel to bring as part of your ration planning. You should check the stove manufacturers’ recommendations, but, typically, three people using one camp stove in the summer will burn about half a quart of fuel per day. Put another way, you should ration about one-sixth of a quart of fuel per person per day for summer trips.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That equation changes dramatically if you plan to camp on a glacier for your entire trip. In that scenario, you will need to melt liters and liters of snow for both cooking and drinking. You might have your stove running for two hours in the morning and two hours at night just melting snow. Double the fuel ration to about one-third of a quart of fuel per person per day for trips that require melting snow for water.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If you like to bake or if you drink lots of hot drinks, tea and the like, you need to bring extra fuel too. Baking, especially, can drain a fuel bottle quickly.")])]), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "ch02lev2sec20"
    }
  }), _c('a', {
    attrs: {
      "id": "ch02lev1sec6"
    }
  }, [_vm._v("Summary for Your Expedition Planning")])]), _c('a', {
    attrs: {
      "id": "ch02lev1sec6"
    }
  }, [_c('p', {
    staticClass: "noindentb"
  }, [_vm._v("If you assess your own abilities, choose your teammates well, define the objectives of your trip, study and plan your route, calculate rations and fuel, and get yourself into good physical shape, you have prepared well for your trip.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("Team and Leadership.")]), _vm._v(" Assess yourself and your teammates. Put together a group of people you trust. Aim for a group that wants to achieve the same goals on the trip. Choose a person with excellent judgment who is respected by the whole group to be your leader.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("Expedition Goals.")]), _vm._v(" Discuss the goals of the trip with your teammates before you go. Discuss the what, where, why, and how. If objectives change during the trip, sit down and discuss new objectives.")])]), _c('p', {
    staticClass: "bull"
  }, [_c('a', {
    attrs: {
      "id": "ch02lev1sec6"
    }
  }), _c('a', {
    attrs: {
      "id": "page_62"
    }
  }, [_vm._v("• "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("Route Planning.")]), _vm._v(" Study your route and discuss it with your teammates over a full set of maps. Learn the regulations where you will be traveling. For longer trips, decide on the best form of resupply given the remoteness of the area you’re traveling in, and then select the best site with the pilot, horsepacker, or friend who will do the resupply.")])]), _c('a', {
    attrs: {
      "id": "page_62"
    }
  }, [_c('p', {
    staticClass: "bull"
  }, [_vm._v("• "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("Contingency Plans.")]), _vm._v(" Try to imagine the unimaginable before you go and then ask yourself how you would manage an emergency situation. Learn the communication systems—trails, roads, and nearby phones— of the area.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("Ration Planning.")]), _vm._v(" Staples are less expensive than freeze-dried foods and allow more flexibility and creativity in your meals. Freeze-dried foods are lighter than staple foods and easier to prepare. Bring freeze-dried foods if you need to go super-light or need the convenience. On short trips, you can plan your rations on a per-meal basis. On long trips, it’s easier to ration between 1.5 and 2.5 pounds per person per day, depending on the difficulty of your route and the nature of travel.")]), _vm._v(" "), _c('hr', {
    staticClass: "hr"
  })]), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "page_62"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn1",
      "id": "ch02fn1"
    }
  }, [_vm._v("I.")]), _vm._v("  For a good treatment of the 1939 K2 expedition, see Andrew J. Kauffman and William L. Putnam, K2: The 1939 Tragedy, Mountaineers Books, 1993.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#ch02-fn2",
      "id": "ch02fn2"
    }
  }, [_vm._v("II.")]), _vm._v(" K2: The 1939 Tragedy; p. 33.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-726606ac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch02.vue
// module id = 84
// module chunks = 0